import { render, staticRenderFns } from "./cancun.vue?vue&type=template&id=6906df3a"
import script from "./cancun.vue?vue&type=script&lang=js"
export * from "./cancun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHero: require('/vercel/path0/components/common/AppHero.vue').default,SearchBox: require('/vercel/path0/components/SearchBox.vue').default,AppBreadcrumb: require('/vercel/path0/components/common/AppBreadcrumb.vue').default,Container: require('/vercel/path0/components/common/Container.vue').default})
